import React, { useState } from 'react';
import ProductSummary from './ProductSummary';
import ConfirmDialog from './ConfirmDialog';

export const PerformanceData = ({
  records,
  editMode,
  editableTitles,
  handleTitleChange,
  handleEditTitle,
  handleMoveNext,
  setEditMode,
  cycleMasterId
}) => {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState('');
  const [confirmAction, setConfirmAction] = useState(() => () => {});
 

  const handleEditClick = (uniqueKey, title) => {
    setConfirmMessage('Are you sure you want to edit this title?');
    setConfirmAction(() => () => {
      setEditMode((prev) => ({ ...prev, [uniqueKey]: true }));
    });
    setConfirmOpen(true);
  };

  return (
    <div className="overflow-x-auto">
      <div className="min-w-[1080px]">
        {/* Table Header */}
        <div className="flex items-center border-b border-gray-300 dark:border-gray-600 pb-2 text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase">
          <div className="w-50 text-left">Permutations</div>
          <div className="flex-1 w-full sm:w-1/2 pl-4">Titles</div>
           
             
              <div className="w-24 text-right">Impressions</div>
              <div className="w-18 text-right">Clicks</div>
              <div className="w-16 text-right pr-2">CTR</div>
              <div className="w-16 text-right pr-2">CPC</div>
              <div className="w-16 text-right">Days</div>
              <div className="w-24 text-center">Status</div>
              <div className="w-32 text-center">Options</div>
           
        </div>

        {/* Table Rows */}
        {Array.isArray(records?.title) &&
          records.title.map((item, idx) => {
            const uniqueKey = `${records.productId}_${idx}`;
            const isEditing = editMode[uniqueKey];

             const rowClass = records.selected_key
            ? item.key === records.selected_key
              ? 'bg-green-50 dark:bg-green-900 font-medium border border-green-500 dark:border-green-400 text-green-800 dark:text-green-100'
              : ''
            : item.key === records.current_key
            ? 'bg-yellow-100 dark:bg-yellow-800 font-medium border border-yellow-500 dark:border-yellow-400 text-yellow-900 dark:text-yellow-100 rounded'
            : '';

            return (
              <div
                key={uniqueKey}
                className={`flex flex-wrap items-start text-sm border-t border-gray-200 py-2 pl-2 ${rowClass}`}
              >
                {/* Permutation */}
                <div className="w-50 text-left font-medium text-gray-800 dark:text-gray-200">
                  {item.key === 'start'
                    ? 'Baseline title'
                    : item.key.charAt(0).toUpperCase() + item.key.slice(1)}
                </div>

                {/* Title Field */}
                <div className="flex-1 w-full sm:w-1/2">
                  {!isEditing ? (
                    <span className="break-words pl-2 text-gray-800 dark:text-gray-200">
                      {item.title}
                    </span>
                  ) : (
                    <input
                      type="text"
                      value={editableTitles[uniqueKey] || item.title}
                      onChange={(e) => handleTitleChange(e, uniqueKey)}
                      className="border px-2 py-1 rounded w-full mt-1"
                    />
                  )}
                </div>

               
                    <div className="w-24 text-right pr-2 text-gray-800 dark:text-gray-200">
                      {item.impressions.toLocaleString()}
                    </div>
                    <div className="w-18 text-right pr-2 text-gray-800 dark:text-gray-200">
                      {item.clicks}
                    </div>
                    <div className="w-16 text-right text-gray-800 dark:text-gray-200">
                      {item.ctr !== 0 && item.ctr !== 'NA' ? `${item.ctr}%` : item.ctr}
                    </div>
                    <div className="w-16 text-right text-gray-800 dark:text-gray-200">
                      {item.cpc}
                    </div>
                    <div className="w-16 text-right pr-1 text-gray-800 dark:text-gray-200">
                      {item.days === 0 ? 'Started' : `${item.days}`}
                    </div>
                    <div className="w-24 text-center pr-2 text-gray-800 dark:text-gray-200">
                      {item.p_status}
                    </div>

                    {/* Options (Edit / Save / Cancel) */}
                    <div className="w-32 text-center mt-2 sm:mt-0 space-x-2">

                      
                      {item.p_status === 'Live' && idx !== records.title.length - 1 ? (  
                      <button 
                            onClick={() => {
                              setConfirmMessage('Are you sure you want to move to the next title?');
                              setConfirmAction(() => () => 
                                handleMoveNext(cycleMasterId, records.productId, idx)
                              );
                              setConfirmOpen(true);
                            }}
                            className="text-blue-600 hover:underline"
                          >
                            Move Next
                          </button>
                      
                      ) :   item.p_status === 'In Queue' &&
                        (!isEditing ? (
                          <button
                            onClick={() => handleEditClick(uniqueKey, item.title)}
                            className="text-blue-600 hover:underline"
                          >
                            Edit
                          </button>
                        ) : (
                          <div className="flex gap-2 justify-center">
                            <button
                              onClick={() =>
                                handleEditTitle(
                                  cycleMasterId,            // test_cycle_id
                                  records.productId,        // product_id
                                  idx,                      // index
                                  uniqueKey,                // uniqueKey
                                  editableTitles[uniqueKey],// new title
                                  item.key,                 // key
                                  item.title                // old title
                                )
                              }
                              className="text-green-600 hover:underline"
                            >
                              Save
                            </button>
                            <button
                              onClick={() => {
                                setEditMode((prev) => ({ ...prev, [uniqueKey]: false }));
                              }}
                              className="text-red-500 hover:underline"
                            >
                              Cancel
                            </button>
                          </div>
                        ))}
                    </div>
                  
              </div>
            );
          })}

        {/* Product Summary */}
        <ProductSummary records={records} />
      </div>

      {/* Confirm Dialog */}
      <ConfirmDialog
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        onConfirm={() => {
          confirmAction();
          setConfirmOpen(false);
        }}
        message={confirmMessage}
      />
    </div>
  );
};
